import {Segment} from 'semantic-ui-react';
import ConsultPackagesList from './consult-packages-list';
import Fetcher from '../shared/fetches/fetcher';
import {fetchConsultPackages} from '../../redux/actions/consult-package';
import EmptyConsultPackaeList from './empty-consult-package-list';

function ConsultPackagesListContainer() {
  return (
    <Segment>
      <Fetcher
        action={fetchConsultPackages}
        stateSelector={state => state.consultPackages}
        renderEmpty={() => <EmptyConsultPackaeList/>}
      >
        {consultPackages => <ConsultPackagesList consultPackages={consultPackages}/>}
      </Fetcher>
    </Segment>
  );
}

export default ConsultPackagesListContainer;
